import { CustomerAdvocacyBadgeItemType, PointSystemInfo } from '@/models/customerAdvocacyModels';
import { AmbassadorError, DispatchEmptyObject, DispatchObject, Paginator } from '@/models/globalModels';
import ApiService from '@/services/ApiService';
import LocalDataService from '@/services/LocalDataService';

import { getProfileData } from '../../auth/actions';
import * as t from '../types';

export const doGetCustomerAdvocacyBadges = () => (dispatch: any) => {
  dispatch(doCustomerAdvocacyBadgesFetching());
  const token = LocalDataService.getAuth();
  ApiService.setToken(token);
  ApiService.getCustomerAdvocacyBadges(LocalDataService.getCompanyId())
    .then((tasks) => {
      dispatch(doCustomerAdvocacyBadgesFetch(tasks));
    })
    .catch((e) => dispatch(doCustomerAdvocacyBadgesFetchError(e)));
};

// REDUX updates //
export const doSetCustomerAdvocacyPoints = (points: PointSystemInfo) => (dispatch: DispatchObject<PointSystemInfo>) => {
  dispatch({
    type: t.SET_CUSTOMER_ADVOCACY_POINTS,
    payload: points,
  });
};

export const doCustomerAdvocacyBadgesFetching = () => (dispatch: DispatchEmptyObject) => {
  dispatch({
    type: t.CUSTOMER_ADVOCACY_BADGES_FETCHING,
  });
};

export const doCustomerAdvocacyBadgesFetch =
  (badges: Paginator<CustomerAdvocacyBadgeItemType>) => (dispatch: DispatchObject<Paginator<CustomerAdvocacyBadgeItemType>>) => {
    dispatch({
      type: t.CUSTOMER_ADVOCACY_BADGES_FETCH,
      payload: badges,
    });
  };

export const doCustomerAdvocacyBadgesFetchError = (error: AmbassadorError) => (dispatch: DispatchObject<AmbassadorError>) => {
  dispatch({
    type: t.CUSTOMER_ADVOCACY_BADGES_FETCH_ERROR,
    payload: { ...error },
  });
};
